// const apiURL = 'https://localhost:44394/';
// const apiURL = 'https://api.chbvreunion.com/';
const apiURL = 'https://congreso.api.duranm.me/';
export class ServiciosRutas {

  serviciosOperaciones = apiURL + 'Operaciones';
  // serviciosCatalogos =   apiURL + 'Catalogos';
  // fileUrl = fileUrl;
}
